import { useForm } from "react-hook-form";

import { FormDialog } from "ui/form-dialog";
import SmsSimulatorPersonasForm from "containers/sms-simulator/sms-simulator-personas/components/persona-modal/sms-simulator-personas-form";

import { SmsSimulatorPersonaModalProps } from "containers/sms-simulator/sms-simulator-personas/sms-simulator-personas.types";

import { PERSONA_FORM_VALIDATION_SCHEMA } from "containers/sms-simulator/sms-simulator-personas/components/persona-modal/sms-simulator-personas-form.constants";

const SmsSimulatorPersonasModal = ({
  onCloseCallback,
  onConfirmCallback,
  title,
  defaultValues = {
    name: "",
    grade: "",
    profileType: "",
    interests: "",
  },
  subheader,
}: SmsSimulatorPersonaModalProps) => {
  const form = useForm({
    mode: "onChange",
    shouldUnregister: true,
    defaultValues,
    resolver: PERSONA_FORM_VALIDATION_SCHEMA,
  });

  return (
    <FormDialog
      open
      onClose={onCloseCallback}
      headline={title}
      description={subheader}
      form={form}
      onSubmit={onConfirmCallback}
      submitButtonText="Submit">
      <SmsSimulatorPersonasForm />
    </FormDialog>
  );
};

export default SmsSimulatorPersonasModal;
